import React from 'react';

import './styles.scss';

interface Props {
    showLoader: boolean;
}

export const Loader = ({ showLoader }: Props) => {
    if (showLoader) {
        return (
            <div className='app-loader'>
                <span className='app-loader__icon'></span>
            </div>
        );
    }

    return null;
};
